import { render } from "./DividerTitle.vue?vue&type=template&id=0565628c"
import script from "./DividerTitle.vue?vue&type=script&lang=js"
export * from "./DividerTitle.vue?vue&type=script&lang=js"

import "./DividerTitle.vue?vue&type=style&index=0&id=0565628c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__